import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import FlatButton from '../FlatButton';
import CompletedIcon from '../Icons/CompletedIcon';

import cl from 'classnames';
import s from './Checkbox.css';

const defaultIsChecked = false;

/**
 * A checkbox input
 */
class Checkbox extends PureComponent {
  inputRef = React.createRef();

  state = {
    checked: this.props.isChecked,
  };

  componentWillReceiveProps(newProps) {
    this.setState({
      checked: newProps.isChecked,
    });
  }

  onKeyDown = (ev) => {
    if (ev.keyCode === 13) {
      this.props.onClick();
    }
  }

  componentDidMount() {
    this.inputRef.current.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount() {
    this.inputRef.current.removeEventListener('keydown', this.onKeyDown)
  }

  toggle = () => {
    this.setState({
      checked: !this.state.checked,
    });
  };

  render() {
    const { label, onClick, className, style, labelClassName, labelStyle } = this.props;
    const { checked } = this.state;

    return (
      <div className={s.Container}>
        <input
          id={label}
          ref={this.inputRef}
          className={cl(s.Checkbox, className)}
          name={label}
          type="checkbox"
          value={label}
          onClick={onClick || this.toggle}
        />

        <div className={s.IconWrapper}>
          <CompletedIcon className={cl(s.Icon, !checked && s.Hidden)} />
        </div>

        <label for={label} className={cl(s.Label, labelClassName)} style={style}>
          {label}
        </label>
      </div>
    );

    // return (
    //   <div className={s.Container} onClick={onClick || this.toggle}>
    //     <FlatButton aria-labelledby="span-label" className={cl(s.Checkbox, className)} style={style}>
    //       <CompletedIcon className={cl(s.Icon, !checked && s.Hidden)} />
    //     </FlatButton>
    //     <span id="span-label" className={cl(s.Label, labelClassName)} style={labelStyle}>
    //       {label}
    //     </span>
    //   </div>
    // );
  }
}
Checkbox.propTypes = {
  /**
   * The checkbox label
   */
  label: PropTypes.string,
  /**
   * Whether the element is checked or not
   */
  isChecked: PropTypes.bool,
  /**
   * Tap event handler
   */
  onClick: PropTypes.func,
  /**
   * Container class name
   */
  className: PropTypes.string,
  /**
   * Container styles
   */
  style: PropTypes.object,
  /**
   * Label class name
   */
  labelClassName: PropTypes.string,
  /**
   * Label styles
   */
  labelStyle: PropTypes.object,
};
Checkbox.defaultProps = {
  isChecked: defaultIsChecked,
};

export default Checkbox;
